import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 2, // 2 minutes
      gcTime: 1000 * 60 * 10, // 10 minutes (formerly cacheTime)
      retry: 2,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 1,
    },
  },
});

// Query key factory for type-safe query keys
export const queryKeys = {
  // Use Cases
  useCases: {
    all: ['useCases'] as const,
    lists: () => [...queryKeys.useCases.all, 'list'] as const,
    list: (filters: Record<string, unknown>) => [...queryKeys.useCases.lists(), filters] as const,
    details: () => [...queryKeys.useCases.all, 'detail'] as const,
    detail: (id: string) => [...queryKeys.useCases.details(), id] as const,
  },

  // AI Tools
  aiTools: {
    all: ['aiTools'] as const,
    lists: () => [...queryKeys.aiTools.all, 'list'] as const,
    list: (filters: Record<string, unknown>) => [...queryKeys.aiTools.lists(), filters] as const,
    details: () => [...queryKeys.aiTools.all, 'detail'] as const,
    detail: (id: string) => [...queryKeys.aiTools.details(), id] as const,
  },

  // Approvals
  approvals: {
    all: ['approvals'] as const,
    pending: () => [...queryKeys.approvals.all, 'pending'] as const,
    history: () => [...queryKeys.approvals.all, 'history'] as const,
  },

  // Users
  users: {
    all: ['users'] as const,
    current: () => [...queryKeys.users.all, 'current'] as const,
  },

  // Directory (in-app role assignments)
  directory: {
    all: ['directory'] as const,
    users: () => [...queryKeys.directory.all, 'users'] as const,
  },

  // Departments (admin-managed list)
  departments: {
    all: ['departments'] as const,
    list: () => [...queryKeys.departments.all, 'list'] as const,
  },

  // Dashboard
  dashboard: {
    stats: (department?: string) =>
      department
        ? (['dashboard', 'stats', { department }] as const)
        : (['dashboard', 'stats'] as const),
    recentActivity: () => ['dashboard', 'recentActivity'] as const,
  },
};
